import { Link } from "react-router-dom";

const BlogCard = ({blogs,title}) => {


    return ( 

        <>
            <div className="d-flex container-xxl flex-grow-1 container-p-y">
                <h1 className="text-success">
                    {title}
                </h1>
            </div>

            {blogs.map((blog) => (
                <div  key={blog.id} className="container-xxl flex-grow-1 container-p-y">
                    <div className="row">
                        <div className="col-lg-12 order-0">
                            <div className="card">
                                <div className="d-flex align-items-end row">
                                    <div className="col-sm-7">
                                        <div className="card-body">
                                            <h5 className="card-title text-primary">{blog.title}! 🎉</h5>
                                            <p className="mb-4">
                                            You have done <span className="fw-medium">72%</span>{blog.body}
                                            </p>
                                            <p>
                                            by <span className="text-info">{blog.author}</span>
                                            </p>
                                            <Link to={`/blogs/${blog.id}`} className="btn btn-sm btn-label-primary">Read Article</Link>
                                        </div>
                                    </div>
                                    <div className="col-sm-5 text-center text-sm-left">
                                        <div className="card-body pb-0 px-0 px-md-4">
                                            <img src="../iusevolutione/assets/img/illustrations/man-with-laptop-light.png" height={140} alt="View Badge User" data-app-dark-img="illustrations/man-with-laptop-dark.png" data-app-light-img="illustrations/man-with-laptop-light.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

        </>

     );
}
 
export default BlogCard;